import React, { useEffect, useRef, useState } from 'react'

import { useStyles } from '../../SkillsAndHobbiesProfile_style'
import { Box, Grid, TextField, Chip, List, ListItem, ListItemText, Typography } from '@material-ui/core'

import Close from '@material-ui/icons/Close'
import IconFactory from 'icons/IconFactory/IconFactory'
import isEmpty from 'lodash.isempty'
import { FormattedMessage } from 'react-intl'

const SkillsAndHobbiesSelection = (props) => {
    const { Title, skillType, availableSkills, setStudentSkillsAndHobbies, studentSkillsAndHobbies } = props
    const classes = useStyles()
    const currentUrl = new URL(window.location.href)
    const profileCompletedWithParser = new URLSearchParams(currentUrl.search).get('parser_result')
    const [maxSkillsReached, setMaxSkillsReached] = useState(false)
    const skillsByType = availableSkills.filter(skill => skill.skill_type === skillType)
    const skillsToDisplay = skillsByType.filter(skill => studentSkillsAndHobbies.includes(skill.value))

    const [search, setSearch] = useState('')
    const [searchSelected, setSearchSelected] = useState()

    const containerRef = useRef()

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                handleSearchClick(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [])

    const addSkill = (skill) => {
        if (!studentSkillsAndHobbies.includes(skill.value)) {
            if (skillType === 'hard' || skillsToDisplay.length < 3) {
                setStudentSkillsAndHobbies([...studentSkillsAndHobbies, skill.value])
            } else {
                setMaxSkillsReached(true)
                setTimeout(() => setMaxSkillsReached(false), 2000)
            }
        }
    }

    const removeSkill = (skillValue) => {
        setMaxSkillsReached(false)
        setStudentSkillsAndHobbies(studentSkillsAndHobbies.filter((s) => s !== skillValue))
    }

    const handleSearchClick = (value) => {
        setSearchSelected(value)
    }

    const filteredSkills = availableSkills.filter((skill) =>
        skill.name.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <Box display="flex" p={1}>
            <Box style={{ flex: 3, padding: 8, marginRight: 8 }} className={(profileCompletedWithParser && !isEmpty(skillsToDisplay)) && classes.aiHighlight}>
                <Grid container spacing={1}>
                    {isEmpty(skillsToDisplay)
                        ? <Typography className={classes.emptyList}><FormattedMessage id={`landing_student_profile_page.${skillType}_skills_empty`}/></Typography>
                        : studentSkillsAndHobbies.map((skillValue) => {
                            const skill = skillsToDisplay.find(elem => elem.value === skillValue)
                            if (!skill) return null
                            return (
                                <Grid item key={skillValue}>
                                    <Chip
                                        className={classes.simpleChip}
                                        label={skill.name}
                                        onDelete={() => removeSkill(skillValue)}
                                        deleteIcon={<Close className={classes.badgeDelete}/>}
                                        size="small"
                                    />
                                </Grid>
                            )
                        })
                    }
                    {maxSkillsReached &&
                        <Typography className={classes.max3}>
                            <FormattedMessage id='landing_student_profile_page.max3'/>
                        </Typography>
                    }
                </Grid>
            </Box>
            <Box ref={containerRef} style={{ flex: 1, padding: 8 }}>
                <Box className={`${classes.textInputContainer}`}>
                    <IconFactory icon='search-regular' className={classes.searchIcon} />
                    <TextField
                        fullWidth
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        placeholder={Title}
                        name='title'
                        value={search}
                        onFocus={() => handleSearchClick(true)}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Box>
                <Box className={`${classes.searchResults} ${searchSelected || classes.closed}`}>
                    <List dense>
                        {filteredSkills.length === 0
                            ? <ListItem button key='No results' style={{ color: 'grey' }}>
                                <ListItemText primary='No results' />
                            </ListItem>
                            : filteredSkills
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((skill) => (
                                    <ListItem
                                        button
                                        key={skill.name}
                                        onClick={() => addSkill(skill)}
                                    >
                                        <ListItemText primary={skill.name} />
                                    </ListItem>
                                ))}
                    </List>
                </Box>
            </Box>
        </Box>
    )
}

export default SkillsAndHobbiesSelection
